export async function wait(ms: number = 0):Promise<any> {
	if(ms < 0) return;
	return new Promise(res => setTimeout(res, ms));
}

export function getTime({h, m, s}): string {

	let hms = [];

	(h !== undefined) && hms.push(h);
	(m !== undefined) && hms.push(m);
	(s !== undefined) && hms.push(s);

	return hms.join(":");
}

export function getVal(obj: any, ...props: string[]): any {
	return obj && props.reduce(
		(result, prop) => result == null ? undefined : result[prop],
		obj
	);
}

export function getter(path) {
	const fragments = path.split('.');

	return object => {
		let val = object;
		for (const part of fragments) {
			val = val[part];
			if(val === undefined) return;
		}
		return val
	}
}


/**
 * Returns closest value from array
 * @param {Array} arr
 * @param {number} val
 */
export function getClosestValue(arr:Array<number>, val:number): number {
	return arr.reduce((prev, curr) => {
		return (Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev);
	});
}

/**
 * @param {number} num
 * @param {number} padlen
 * @param {string} padchar
 */
export function paddy(num: number, padlen: number, padchar: string = "0"): string {
	let pad = new Array(1 + padlen).join(padchar);
	return (pad + num).slice(-pad.length);
}

/**
 * @param {string} prefix
 * @param {number} start
 * @param {number} stop
 * @param {string} suffix
 * @param {number} zeroPad
 * @returns {Array}
 */
export function generateTextures(prefix:string = "", start:number = 0, stop:number = 0, suffix:string = "", zeroPad:number = 0, exclude:Array<any> = []) {
	let textures = [];

	for(let i = start; i <= stop; i++) {
		if(exclude.includes(i)) {
			continue;
		}

		// @ts-ignore
		textures.push(PIXI.Texture.from(prefix + paddy(i, zeroPad, "0") + suffix));
	}

	return textures;
}

export function generateTexureNames(prefix = "", start = 0, stop = 0, suffix = "", zeroPad = 0) {
	let txtNames = [];
	for(let i = start; i <= stop; i++) {
		txtNames.push(prefix + paddy(i, zeroPad, "0") + suffix);
	}
	return txtNames;
}

export function generateRange(from, to) {
	let arr = [];
	for (let i = from; i <= to; i++) {
		arr.push(i)
	}
	return arr;
}

export function generateExcludes(excludes = []) {
	let excl = [];
	for(let i = 0; i < excludes.length; i++) {
		let val = excludes[i];
		if(typeof val === "number") {
			excl.push(val)
		} else if(typeof val === "object") {
			excl.push(...generateRange(val[0], val[1]));
		}
	}
	return excl;
}

/**
 * @param {Array} a
 * @returns {Array}
 */
export function reverseArray (a) {
	var ret = [];
	for(var i = a.length - 1; i >= 0; i--)
	{
		ret[ret.length] = a[i];
	}
	return ret;
}

/**
 * @param {Array} a
 * @returns {Array}
 */
export function copyArray (a) {
	return a.slice(0);
}

/**
 * @param {Array} a
 * @returns {Array}
 */
export function shuffleArray(a) {
	var j, x, i;

	for (i = a.length; i; i--) {
		j = Math.floor(Math.random() * i);
		x = a[i - 1];
		a[i - 1] = a[j];
		a[j] = x;
	}

	return a;
}

/**
 * @param {Array} arr
 * @returns {*}
 */
export function getArrayRandValue (arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function getRandomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random float between min (inclusive) and max (exclusive)
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function getRandomFloat(min, max) {
	return Math.random() * (max - min) + min;
}

/**
 * @returns {boolean}
 */
export function getRandomBoolean() {
	return Math.random() >= 0.5;
}

/**
 * @param {Array} numArray - array of number
 * @returns {number}
 */
export function getMaxOfArray(numArray) {
	return Math.max.apply(null, numArray);
}

/**
 * @param {Array} numArray - array of number
 * @returns {number}
 */
export function getMinOfArray(numArray) {
	return Math.min.apply(null, numArray);
}

/**
 * @param {Object} obj
 * @returns {*}
 */
export function randomProperty(obj) {
	var keys = Object.keys(obj);
	return obj[keys[ keys.length * Math.random() << 0]];
}

export function capitalize(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function numberWithSpaces(number, round = true){
	if (round){
		return (number | 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
	}

	else {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
	}

}

/* https://github.com/kvz/locutus/blob/master/src/php/strings/number_format.js */
export function numberFormat(number, decimals, decPoint, thousandsSep)
{
	let num = getMin2Decimals(number, decimals, thousandsSep)

	if(decPoint !== '.') {
		num = num.replace(".", decPoint);
	}

	return num
}

function getMin2Decimals(number, decimals, thoudandsSep): string {
	let num = (number * 1).toFixed(Math.max(2, Math.min((( number * 1).toFixed(decimals).replace(/0+$/, '').split('.')[1] || []).length, decimals)))
	let parts = num.split('.');
	let part1 = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thoudandsSep);
	let part2 = parts[1];
	return part1 + '.' + part2
}

export function intFormat(num) {
	if(num == 1000) return "1 000";

	let str = "";
	let n = "";
	while(num / 1000 > 1) {
		num /= 1000;
		n = (num % 1).toFixed(3).substr(2);
		str = n + " " + str;
	}

	str = (num | 0) + " " + str;
	return str.trim();
}

export function getNoUISliderRange(range = [], decimals: number = 2): { min: number, max: number } {

	if(!range.length) {
		console.warn("range is empty!", range);
		return { "min": 0, "max": 1};
	}

	if(range.length === 1) {
		return { "min": 0, "max": range[0]};
	}

	let r = {min: 0, max: 0};
	let d = range.length - 1;

	for(let i = 0; i <= d; i++) {
		let key = (i == 0) ? "min" : (i == d) ? "max" : (i / d * 100).toFixed(decimals) + "%";
		let val = range[i];
		r[key] = val;
	}

	return r;
}

export function getDigits(num) {

	let c = 1;
	num/= 10;
	while(num >= 1) {
		c++;
		num/= 10;
	}

	return c - 1;
}

export function sec_to_mmss(num) {
	let sec_num = parseInt(num, 10);
	let ho_time = Math.floor(sec_num / 3600);
	let mi_time = Math.floor((sec_num - ( ho_time * 3600)) / 60);
	let se_time = sec_num - (ho_time * 3600) - (mi_time * 60);

	let mi = "" + mi_time;
	let se = "" + se_time;

	if (mi_time < 10) { mi = "0" + mi_time; }
	if (se_time < 10) { se = "0" + se_time; }

	return mi + ':' + se;
}

export function sec_to_mmss_object(num) {
	let sec_num = parseInt(num, 10);
	let ho_time = Math.floor(sec_num / 3600);
	let mi_time = Math.floor((sec_num - ( ho_time * 3600)) / 60);
	let se_time = sec_num - (ho_time * 3600) - (mi_time * 60);

	let ho = "" + ho_time;
	let mi = "" + mi_time;
	let se = "" + se_time;

	if (ho_time < 10) { ho = "0" + ho_time; }
	if (mi_time < 10) { mi = "0" + mi_time; }
	if (se_time < 10) { se = "0" + se_time; }

	return {
		h: ho,
		m: mi,
		s: se
	}
}

export function getTimeNow() {
	return new Date(Date.now()).getTime();
}

export function getISOTime(seconds) {

	seconds = seconds || 0;

	let t = Date.now() + (seconds * 1000);
	return new Date(t).toISOString();
}

export function getTimeFromISO(isoTime) {
	return new Date(isoTime).getTime()
}


export function removeUndefined(obj) {
	for (let k in obj) if (obj[k] === undefined) delete obj[k];
	return obj;
}

export function isLocalhost() {
	return location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname.startsWith('192.168.') || location.hostname.startsWith('bs-local.com');
}

export function replaceParam(txt, param, value) {
	if(value != null) {
		txt = txt.replace('{' + param + '}', value);
	}
	return txt;
}

export function updateVh(height: number = window.innerHeight) {
	let vh = height * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function vh(value) {
	return value * parseFloat(document.documentElement.style.getPropertyValue('--vh'));
}

export function vw(value) {
	return value * window.innerWidth * 0.01;
}

export function createElement(id: string, classList: Array<string>, tag: string = 'div'): HTMLElement {
	let element = document.createElement(tag)
	if (id) element.id = id
	for (let item of classList) {
		element.classList.add(item)
	}
	return element
}

let iframe = null
export function isInIframe(): boolean {
	if (iframe !== null) {
		return iframe
	}
	try {
		return iframe = window.self !== window.top;
	} catch (e) {
		return iframe = true;
	}
}